import { createContext, useContext, useMemo, type ReactNode } from "react";
import { useMascotMood } from "./useMascotMood";
import type { MascotMood } from "./types";

export interface PracticeMascotContextValue {
    mood: MascotMood;
    pulse: (mood: MascotMood, ms?: number) => void;
    reset: () => void;
}

const PracticeMascotContext = createContext<PracticeMascotContextValue | null>(null);

export function usePracticeMascotContext(): PracticeMascotContextValue {
    const ctx = useContext(PracticeMascotContext);
    if (!ctx) {
        throw new Error("usePracticeMascotContext must be used within PracticeMascotProvider");
    }
    return ctx;
}

export function PracticeMascotProvider({ children }: { children: ReactNode }) {
    const mascot = useMascotMood({ baseMood: "idle" });
    const value = useMemo(
        () => ({ mood: mascot.mood, pulse: mascot.pulse, reset: mascot.reset }),
        [mascot.mood, mascot.pulse, mascot.reset],
    );
    return <PracticeMascotContext.Provider value={value}>{children}</PracticeMascotContext.Provider>;
}